import Cookies from 'js-cookie';

export default ({Vue, store}) => {

  Vue.prototype.$cookies = Cookies;
  store.$cookies = Cookies;
}
